let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("jpgAW")).then(() => parcelRequire('jylD4'));